import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

const CreateCharacterCard: React.FC = () => {
  return (
    <Link
      to="/create-character"
      className="relative bg-zinc-800 rounded-2xl shadow-lg overflow-hidden flex flex-col h-full group cursor-pointer hover:bg-zinc-700 transition-colors"
      style={{ textDecoration: 'none' }}
    >
      {/* Main content area matching CharacterCard dimensions */}
      <div className="relative w-full h-full min-h-72 aspect-[3/4] flex flex-col items-center justify-center">
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-pink-600/50 to-purple-600/50" />
        
        {/* Content */}
        <div className="relative z-10 flex flex-col items-center justify-center text-center p-6">
          <div className="size-16 bg-pink-600/20 rounded-full flex items-center justify-center mb-4 group-hover:bg-pink-600/30 transition-colors">
            <Sparkles className="size-8 text-pink-500" />
          </div>
          <div className="text-white text-xl font-bold mb-2">
            <span>Create New Contact</span>
          </div>
          <div className="text-zinc-300 text-sm invisible">
            <span>Design your perfect companion</span>
          </div>
        </div>

        {/* Gradient overlay for consistency with CharacterCard */}
        <div className="absolute bottom-0 left-0 w-full h-28 bg-gradient-to-t from-zinc-900/90 to-transparent pointer-events-none z-20" />
        
        {/* Plus icon in top right like message icon in CharacterCard */}
        <div className="absolute top-3 right-3 bg-pink-700 hover:bg-pink-600 text-white rounded-full p-3 shadow-lg z-30 group-hover:scale-105 transition-transform">
          <Sparkles size={22} />
        </div>
      </div>

      {/* Info section matching CharacterCard structure */}
      <div className="absolute bottom-0 left-0 w-full px-4 pb-2 pt-10 flex flex-col z-30 text-left">
        <div className="flex text-lg md:text-2xl font-bold drop-shadow-[0_2px_6px_rgba(0,0,0,0.8)]">
          <span className="flex-[1_1_auto] overflow-hidden text-ellipsis text-nowrap text-white">Your AI</span>
        </div>
        <div className="text-sm text-zinc-200 mb-2 line-clamp-1 drop-shadow">
          <span>Design the perfect companion</span>
        </div>
        <div
          className="flex max-w-full overflow-y-auto gap-1 pr-3"
          style={{
            scrollbarWidth: 'none',
            maskImage: 'linear-gradient(to right, black 94%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to right, black 94%, transparent 100%)',
          }}
        >
          <span className="px-2 py-0.5 rounded-full bg-pink-900 text-xs text-pink-200 capitalize text-nowrap">
            <span>Custom</span>
          </span>
        </div>
      </div>
    </Link>
  );
};

export default CreateCharacterCard; 